import { bindable } from "aurelia-framework";

export class ToggleButtonCustomElement {
    @bindable({ defaultBindingMode: "twoWay", changeHandler: "onCheckedHandler" })
    public checked = false;

    @bindable onChecked: (value: boolean) => void;

    private onCheckedHandler(value: boolean) {
        if (this.onChecked) {
            this.onChecked(value);
        }
    }
}
